import { useQuery } from "@tanstack/react-query";
import { RiskItem } from "../types";
import { programmeDashboardApi } from "../api/programmeDashboard";

const mapApiRiskToRiskItem = (apiRisk: {
  risk_id: string;
  title: string;
  risk_description: string;
  project_ref?: string;
  category?: string;
  status?: string;
  impact_score?: number;
  probability_score?: number;
}): RiskItem => {
  const impactScore = apiRisk.impact_score ?? 0;
  const probabilityScore = apiRisk.probability_score ?? 0;
  const riskScore = impactScore * probabilityScore;

  return {
    id: apiRisk.risk_id,
    title: apiRisk.title,
    description: apiRisk.risk_description,
    project_ref: apiRisk.project_ref,
    category: apiRisk.category,
    status: apiRisk.status,
    impact_score: apiRisk.impact_score,
    probability_score: apiRisk.probability_score,
    risk_score: riskScore > 0 ? riskScore : undefined,
  };
};

export const useRisks = (category: string, { portfolio_id, quickFilters }: { portfolio_id: string | undefined, quickFilters: any }) => {
  const { data, isLoading, isError, error } = useQuery({
    queryKey: ["risks", category, portfolio_id],
    queryFn: () => programmeDashboardApi.fetchRisks({
      page: 1,
      limit: 5,
      sort_field: "impact_score",
      sort_order: "ASC",
      category,
      status: "open",
      portfolio_id: portfolio_id
    }),
  });

  const risks: RiskItem[] = data?.data?.rows
    ? data.data.rows.map(mapApiRiskToRiskItem)
    : [];

  return {
    risks,
    isLoading,
    isError,
    error:
      error instanceof Error ? error.message : "Failed to fetch risks",
  };
};

